<style lang="less" scoped>
</style>
<template>
  <VRemoteSelect
    v-bind="$attrs"
    item-value="id"
    :item-text="(c) => (`${c.spu_name}`)"
    :find_api="$util.api.cya_spu_detail"
    :search_api="$util.api.cya_spu_select_search_operating"
    :item-default="{id: 0, uid: '', spu_name: ''}"
    v-on="$listeners"
  />
</template>
<script>
import VRemoteSelect from '@/vuetify_custom/v-remote-select.vue';

export default {
  components: {VRemoteSelect},
  inheritAttrs: false,
}
</script>
